const currencyFormatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
export const formatCurrency = currencyFormatter.format;
export const isNumber = (data) => typeof data === 'number';
export const pickBy = (object) => {
  const obj = {};
  for (const key in object) {
    if (object[key]) {
      obj[key] = object[key];
    }
  }
  return obj;
};

export const goToCustomUrl = (url) => {
  window.location.href = url;
};
